import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { ProductPromotionItem } from './product-item'

export const ProductPromotion = () => {
  const { product } = useProductDetailSafe()
  const t = useTranslations('product_detail.title')

  const promotionActive = product?.promotions?.filter(
    (promotion) => promotion.show_in_detail
  )

  if (!promotionActive || promotionActive.length === 0) {
    return null
  }

  return (
    <div
      data-label='product-promotion'
      className='relative mx-auto w-full overflow-hidden rounded-xl border border-[#273BCD] md:mb-4 lg:mb-6'
    >
      {/* Header */}
      <div className='flex w-full items-center rounded-t-lg bg-gradient-to-r from-[#273BCD] to-[#1C2B9D] px-5 py-2 text-white'>
        <Image
          src={'/icons/icon-gift-promotion.svg'}
          alt='Logo'
          width={20}
          height={20}
          className='mr-2'
        />
        <div className='text-sm'>{t('special_offer_just_for_you')}</div>
      </div>

      <Carousel
        opts={{
          align: 'start',
          duration: 50,
          skipSnaps: false,
        }}
        className='w-full px-4'
      >
        <CarouselContent className='gap-2 px-4 py-4'>
          {promotionActive?.map((promotion, index) => (
            <CarouselItem
              key={promotion.id}
              className={cn(
                'basis-4/5 will-change-transform md:basis-3/4',
                index === 0 || index === promotionActive.length - 1
                  ? 'pl-0'
                  : 'pl-4'
              )}
              data-product-id={promotion.id}
            >
              <ProductPromotionItem product={promotion} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
    </div>
  )
}

const CarouselNavigation = () => {
  return (
    <div className='absolute -top-5 right-14'>
      <div className='relative'>
        <CarouselPrevious
          className='absolute left-0 h-5 w-5'
          variant='black'
          hideIfStart
        />
        <CarouselNext className='absolute h-5 w-5' variant='black' hideIfEnd />
      </div>
    </div>
  )
}
